export const locales = require('./locales.json').data;

document.querySelectorAll('#language-selector-menu a').forEach(option => {
    option.addEventListener('click', (e) => {
        if (e.target.getAttribute('href') !== '') {
            // correct href is set, no need for manual location change
            return;
        }

        e.stopPropagation();
        e.preventDefault();

        let url = new URL(window.location);
        url.pathname = url.pathname.replace(buildLocaleRegex(), '');
        url.pathname = (e.target.id === 'default' ? '' : e.target.id) + url.pathname;
        window.location = url.toString();
    });
});

function buildLocaleRegex() {
    let regex = [];

    for (let locale of locales) {
        regex.push(`\\/${locale}`);
    }

    return new RegExp(regex.join('|'));
}